export default defineNuxtPlugin(() => {
  if (!process.client) return

  const initCapacitor = async () => {
    const { App } = await import('@capacitor/app')
    const router = useRouter()

    App.addListener('backButton', () => {
      const dialogs = document.querySelectorAll('dialog:modal')
      if (dialogs !== null && dialogs[0]) {
        ;(dialogs[0] as HTMLDialogElement).close()
      } else {
        if (window.history.length <= 1 || window.history.state.back === null) {
          App.exitApp()
        } else {
          router.back()
        }
      }
    })
  }

  initCapacitor()
})
